// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__c2-kA","left":"styles_left__2KiCh"};